import { render } from "./HandleBikes.vue?vue&type=template&id=1bdca972&ts=true"
import script from "./HandleBikes.vue?vue&type=script&lang=ts"
export * from "./HandleBikes.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__